import { Component, OnInit } from '@angular/core';
import { CurrentEnvironmentService } from '@modules/common/services/current-environment.service';
import { EnvironmentListService } from '@modules/common/services/environment-list.service';
import { EnvironmentModel } from '@modules/common/models/environment-model';

@Component({
    selector: 'app-nav-env-picker',
    templateUrl: './nav-env-picker.component.html',
    styleUrls: ['./nav-env-picker.component.scss']
})
export class NavEnvPickerComponent implements OnInit {
    public environments?: EnvironmentModel[];
    public selectedEnvironment?: EnvironmentModel;

    constructor(
        private _environmentListService: EnvironmentListService,
        private _currentEnvironmentService: CurrentEnvironmentService
    ) { }

    public ngOnInit(): void {
        this._environmentListService.environmentListChanged.subscribe(result => {
            this.environments = result;

            if (this._currentEnvironmentService.getCurrentEnvironmentName()) {
                this.selectedEnvironment = this.environments.filter(x => x.name!.toLowerCase() == this._currentEnvironmentService.getCurrentEnvironmentName().toLowerCase())[0];
                if (this.selectedEnvironment && this.selectedEnvironment.name != this._currentEnvironmentService.getCurrentEnvironmentName()) {
                    this.selectEnvironment(this.selectedEnvironment);
                }
            }

            if (!this.selectedEnvironment || !this.environments.some(x =>x.name!.toLowerCase() == this.selectedEnvironment!.name!.toLowerCase())) {
                this.selectedEnvironment = undefined;
                if (this.environments.length) {
                    this.selectEnvironment(this.environments[0]);
                }
            }
        });
    }

    public selectEnvironment(environment?: EnvironmentModel): void {
        this._currentEnvironmentService.setCurrentEnvironment(environment && environment.name);
        this.selectedEnvironment = environment;
    }
}